<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg5>
            <h2>OnePlatform</h2>
          </v-flex>
          <v-flex xs11 lg6 class="text-end">
            <!-- <v-btn
              color="#077893"
              rounded
              dark
              small
              @click="Fn_SyncBot"
              :loading="LoadingSync"
            >
              Import Excel
            </v-btn> -->
          </v-flex>
        </v-layout>
        <!-- <b class="red--text mr-1">*</b>
            <b
              v-if="$t('default') === 'th'"
              class="red--text mr-1"
              style="font-size: 0.8rem"
              >เพิ่ม BOT CMP ให้กับทุกคนใน Business</b
            >
            <b v-else class="red--text mr-1" style="font-size: 0.8rem"
              >Add BOT CMP to everyone in business</b
            > -->

        <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg pb-2">
              <v-tabs v-model="tab" align-with-title color="#077893">
                <v-tabs-slider color="#077893"></v-tabs-slider>

                <v-tab v-for="item in items" :key="item">
                  {{ $t(item) }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <EmployeeOneID />
                </v-tab-item>
                <v-tab-item>
                  <EmployeeCMP />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- <SearchConsentLogOnechatIndex /> -->
        <SendOnechatDetail />

        <!-- <LogOnechat /> -->
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import EmployeeCMP from "@/views/Admin/Consent/OnePlatform/EmployeeCMP.vue";
import EmployeeOneID from "@/views/Admin/Consent/OnePlatform/EmployeeOneID.vue";
import SendOnechatDetail from "@/views/Admin/Consent/OnePlatform/SendOnePlatformDetail.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
// import LogOnechat from '../ConsentOnechat/LogOnechat/ConsentLogOnechatIndex.vue'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    OverlaySearch,
    EmployeeCMP,
    EmployeeOneID,
    // LogOnechat,
    // SearchConsentLogOnechatIndex,
    SendOnechatDetail,
  },
  data: function () {
    return {
      tab: null,
      items: [this.$t("onechat.new1"), this.$t("onechat.new2")],
      valid: true,
      loadingDownloadData: true,
      LoadingSync: false,
    };
  },
  computed: {},
  mounted() {
    setTimeout(() => (this.loadingDownloadData = false), 500);
  },
  methods: {
    async Fn_SyncBot() {
      this.LoadingSync = true;
      const payload = {
        AccessToken: this.$cookies.get("OneAccessToken"),
        BusinessId: this.$cookies.get("BusinessId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/AddFrindBot",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSync = false;
          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: "Sync CMP Bot Success",
            });
            // window.location.reload();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSync = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
  created() {},
  watch: {},
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.v-stepper__content {
  padding: 0 !important;
}

.c-border {
  border-style: solid;
  border-color: #87e8de !important;
  border-width: 1px;
}

.--text {
  color: #13c2c2;
}

.ff3296--text {
  color: #ff3296;
}
</style>

<style>
input#input-45,
input#input-50 {
  cursor: pointer !important;
}
</style>
